export default __webpack_public_path__ + "static/media/0@6mm_bag.8f609006.jpg";